module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('module-template', [_c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-19011584!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/businessArea/components/BusinessArea.vue
// module id = 893
// module chunks = 2